import { MenuIdProjects } from '@jira/navigation-apps__constants/src/MenuIdProjects.tsx';
import { SidebarIdProjectSettings } from '@jira/navigation-apps__constants/src/SidebarIdProjectSettings.tsx';
import { getConsolidationStateResource } from '@jira/router-resources__eoc-tenant-info/src/getConsolidationStateResource.tsx';
import { LazyAtlassianNavigation } from '@jira/navigation-apps__atlassian-navigation/src/async.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { jsmChangeManagementSettingsGitLabGatingResource } from '@jira/router-resources__jsm-change-management-settings/src/useGitLabGatingResource.tsx';
import { getServiceDeskSettingsResources } from '@jira/router-resources__service-desk-common/src/getServiceDeskSettingsResources.tsx';
import { serviceDeskContextResource } from '@jira/router-resources__service-desk-context/src/serviceDeskContextResource.tsx';
import { featuresResource } from '@jira/router-resources__service-project-features/src/featuresResource.tsx';
import { projectSettingsServicedeskChangeManagementRoute } from '@jira/router-routes__project-settings-product-routes-service-desk-routes/src/projectSettingsServicedeskChangeManagementRoute.tsx';
import { serviceProjectLayout } from '@jira/platform__layouts-service-project-layout/src/index.tsx';
import { changeManagementSettingsProjectConfigurationResource } from '@jira/router-resources__jsm-change-management-settings/src/changeManagementSettingsProjectConfigurationResource.tsx';
import { browserOnlyResourceWithCondition } from '@jira/router-resources__utils/src/resourceWithCondition.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import ServiceDeskChangeManagementSettings, {
	LazyProjectSettingsServiceDeskChangeManagement,
} from './ui/service-desk-change-management/index.tsx';
import type { Route } from '@atlassian/react-resource-router';

export const projectSettingsServicedeskChangeManagementRouteEntry: Route = createEntry(
	projectSettingsServicedeskChangeManagementRoute,
	() => ({
		group: 'project-settings-servicedesk',
		ufoName: 'service-management.change-management-settings',
		// eslint-disable-next-line no-restricted-syntax
		component: ServiceDeskChangeManagementSettings,
		layout: serviceProjectLayout,

		navigation: {
			menuId: MenuIdProjects,
			sidebarId: SidebarIdProjectSettings,
		},

		resources: [
			...getServiceDeskSettingsResources(),
			serviceDeskContextResource,
			browserOnlyResourceWithCondition(
				() => !fg('jfp-magma-fix-cm-settings-sync-dynamic-import'),
				changeManagementSettingsProjectConfigurationResource,
			),
			jsmChangeManagementSettingsGitLabGatingResource,
			featuresResource,
			getConsolidationStateResource(),
		],

		forPaint: [LazyAtlassianNavigation, LazyProjectSettingsServiceDeskChangeManagement],

		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);
